import { render, staticRenderFns } from "./PageCtas.vue?vue&type=template&id=519b714e&scoped=true&"
import script from "./PageCtas.vue?vue&type=script&lang=js&"
export * from "./PageCtas.vue?vue&type=script&lang=js&"
import style0 from "./PageCtas.vue?vue&type=style&index=0&id=519b714e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519b714e",
  null
  
)

export default component.exports